/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonSerieUser,
    JsonSerieUserFromJSON,
    JsonSerieUserFromJSONTyped,
    JsonSerieUserToJSON,
} from './JsonSerieUser';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonSerieUser
 */
export interface ApiResultOfListOfJsonSerieUser {
    /**
     * 
     * @type {Array<JsonSerieUser>}
     * @memberof ApiResultOfListOfJsonSerieUser
     */
    data?: Array<JsonSerieUser>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonSerieUser
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonSerieUser
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonSerieUser
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonSerieUser
     */
    result?: ApiResultOfListOfJsonSerieUserResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonSerieUserResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonSerieUserFromJSON(json: any): ApiResultOfListOfJsonSerieUser {
    return ApiResultOfListOfJsonSerieUserFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonSerieUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonSerieUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonSerieUserFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonSerieUserToJSON(value?: ApiResultOfListOfJsonSerieUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonSerieUserToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

